import React from 'react';
import { Box, Spacer, Typography, Image, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ModalLocal } from '@components';
import { modals } from '@modals';
import { imagesBcp } from '@assets';
import { Close } from '@icons';
import { rem } from '@helpers';
import { useAllBenefits } from './allBenefits.helper';
import { useSelectedSolution } from '@store';
import { Anything } from '@types';
import './style.css';

export const AllBenefits: React.FC = () => {
	const { palette } = useTheme();

	const solutionSelected = useSelectedSolution();

	const { resources, onCloseRequest } = useAllBenefits();

	return (
		<ModalLocal
			name={modals.allBenefits}
			contentCustomStyle={{
				padding: 0,
				width: rem(596),
			}}
			onCloseRequest={onCloseRequest}
			middleContent={{
				type: 'custom',
				content: (
					<>
						<Box
							styles={{
								flexDirection: 'column',
								padding: '32px',
								boxShadow: '0px 0px 20px rgba(46, 54, 65, 0.2)',
								width: '100%',
							}}
						>
							<Box
								styles={{
									width: '100%',
								}}
							>
								<Image source={imagesBcp.avatarBank} styles={{ width: rem(40), height: rem(40) }} />
								<Box
									styles={{
										width: '100%',
										justifyContent: 'left',
										textAlign: 'center',
										alignItems: 'center',
										whiteSpace: 'nowrap',
										marginLeft: rem(16),
									}}
								>
									<Typography appearance="subtitle-100-04">{solutionSelected?.name}</Typography>
								</Box>
								<Box
									styles={{
										width: '100%',
										justifyContent: 'end',
										alignItems: 'center',
									}}
									onPress={onCloseRequest}
								>
									<Close color={palette.global.ui9} width={rem(16)} height={rem(16)} />
								</Box>
							</Box>
							<Spacer vertical={rem(24)} />
							<Typography appearance="body-75-02">{resources.subtitle}</Typography>
							<Spacer vertical={rem(8)} />
						</Box>
						<Box styles={{ flexDirection: 'column', width: '100%' }}>
							{/* Title Benefits */}
							<Box styles={{ flexDirection: 'column', width: '100%', padding: '24px 24px 0px' }}>
								<Typography appearance="body-100-04">{resources.benefits}</Typography>
								<Spacer vertical={rem(4)} />
								<div
									style={{ width: '40px', height: '4px', background: '#D1005D', borderRadius: '8px' }}
								/>
								<Spacer vertical={rem(24)} />
							</Box>
							{/* List of Benefits */}
							<div
								style={{
									overflowY: 'scroll',
									width: '100%',
									height: '363px',
									padding: '0px 24px 0px',
								}}
								className="custom-scrollbar"
							>
								{solutionSelected?.benefits.map((benefit) => {
									return (
										<>
											<Typography
												appearance="microcopy-75-03"
												alternativeStyleProperties={{ color: palette.global.ui60 } as Anything}
											>
												{benefit.title.toUpperCase()}
											</Typography>
											<Spacer vertical={rem(4)} />
											<Typography appearance="microcopy-75-03">{benefit.subtitle}</Typography>
											<Spacer vertical={rem(24)} />
										</>
									);
								})}
								{/* Addition to the Benefits */}
								<Typography
									appearance="microcopy-75-03"
									alternativeStyleProperties={{ color: palette.global.ui60 } as Anything}
								>
									{resources.stampDuty.toUpperCase()}
								</Typography>
								<Spacer vertical={rem(32)} />
								<Typography
									appearance="microcopy-75-03"
									alternativeStyleProperties={{ color: palette.global.ui60 } as Anything}
								>
									{resources.additionalNote.toUpperCase()}
								</Typography>
								<Spacer vertical={rem(32)} />
								<Typography appearance="microcopy-25-03">{resources.annualFees}</Typography>
								<Spacer vertical={rem(28)} />
							</div>
							<Spacer vertical={rem(28)} />
						</Box>
					</>
				),
			}}
		/>
	);
};
